import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function RefreshIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="4 4 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C9.02554 18 6.55661 15.8356 6.08226 12.9958C5.99127 12.4511 5.55229 12 5 12C4.44772 12 3.99344 12.45 4.06165 12.998C4.55286 16.9453 7.9197 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.61062 4 7.46589 5.04751 6 6.70835L6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5V9C4 9.55229 4.44772 10 5 10H9C9.55229 10 10 9.55229 10 9C10 8.44771 9.55229 8 9 8H7.52779C8.62643 6.7725 10.223 6 12 6Z" />
      </svg>
    </Icon>
  );
}
